import { useState } from 'react'
import { useStyletron } from 'baseui'
import { SIZE } from 'baseui/input'
import SDInput from '@/shared/components/SDComponents/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { KIND, SIZE as BTN_SIZE } from 'baseui/button'
import { Check } from 'baseui/icon'
import PropTypes from 'prop-types'

const EditableCell = ({ value, onSave, placeholder }) => {
  const [editing, setEditing] = useState(false)
  const [inputValue, setInputValue] = useState(value || '')
  const [css] = useStyletron()

  const containerStyle = css({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: '120px',
  })

  const textStyle = css({
    cursor: 'pointer',
    ':hover': { textDecoration: 'underline' },
  })

  const handleSave = () => {
    setEditing(false)
    if (inputValue !== value) {
      onSave(inputValue)
    }
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') handleSave()
    if (e.key === 'Escape') {
      setInputValue(value || '')
      setEditing(false)
    }
  }

  if (editing) {
    return (
      <div className={containerStyle}>
        <SDInput
          id='editable-cell'
          size={SIZE.mini}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          autoFocus
          overrides={{
            Root: { style: { minWidth: '100px' } },
          }}
        />
        <SDButton size={BTN_SIZE.mini} kind={KIND.secondary} onClick={handleSave}>
          <Check size={14} />
        </SDButton>
      </div>
    )
  }

  return (
    <span className={textStyle} onClick={() => setEditing(true)} title='Cliquer pour modifier'>
      {value || '-'}
    </span>
  )
}

EditableCell.propTypes = {
  value: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

export default EditableCell
